import { ChangeDetectionStrategy, Component, HostListener, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  readonly visible = input.required<boolean>();
  readonly title = input.required<string>();
  readonly message = input.required<string>();
  readonly confirmLabel = input.required<string>();
  readonly cancelLabel = input.required<string>();
  readonly busy = input<boolean>(false);
  // Kopf-Icon; Default bleibt 'delete', damit bestehende Consumer unveraendert
  // bleiben. Fuer nicht-loeschende Aktionen (z. B. NEX-797 „Verknuepfung loesen")
  // kann ein passenderes Icon (link_off) uebergeben werden.
  readonly icon = input<string>('delete');
  readonly confirmColor = input<'warn' | 'primary'>('warn');
  readonly confirmDisabled = input<boolean>(false);
  readonly showCancel = input<boolean>(true);
  // Breitere Karte fuer projizierte Listen, z. B. Zeilen alt/neu beim Umbenennen (NEX-1278).
  readonly wide = input<boolean>(false);

  readonly confirmed = output<void>();
  readonly cancelled = output<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.visible()) this.cancel();
  }

  // While busy the action already runs on the server; closing now would hide its result.
  cancel(): void {
    if (!this.busy()) this.cancelled.emit();
  }

  // Tasten aus dem Dialog erreichen die Seite nicht; Escape muss deshalb hier schon
  // schließen, der Document-Listener sieht es nicht.
  onCardKeydown(event: KeyboardEvent): void {
    event.stopPropagation();
    if (event.key === 'Escape') this.cancel();
  }
}
